export const Attendance = {
    attence:{
        '考勤':'考勤',
        '传统考勤':'傳統考勤',
        '数字考勤':'數字考勤',
        'GPS考勤':'GPS考勤',
        '二维码考勤':'二維碼考勤',
        "扫码考勤":"掃碼考勤",
        '签入签出考勤':'簽入簽出考勤',
        '系统提示':'系統提示',
        '本次考勤为扫码考勤':'本次考勤為掃碼考勤，請您用微信掃壹掃老師的大屏幕的二維碼進行簽到',
        '签到成功':'簽到成功',
        '签出成功':'簽出成功',
        '未到签出时间':'未到簽出時間',
        '还未到签出时间':'還未到簽出時間',
        '此时签出视为早退':'此時簽出視為早退',
        "新建考勤":"新建考勤",
        "考勤名称":"考勤名稱",
        "请输入考勤名称":"請輸入考勤名稱",
        "选择考勤方式":"選擇考勤方式",
        "编辑考勤名称":"編輯考勤名稱",
        "编辑考勤":"編輯考勤",
        "删除考勤":"刪除考勤",
        "查看GPS与可疑代签":"查看GPS與可疑代簽",
        "取消考勤":"取消考勤",
        "确定要删除本次考勤吗":"確定要刪除本次考勤嗎?",
        "异常签到":"異常簽到",
        "可疑代签":"可疑代簽",
        "GPS":"GPS",
        "无异常签到成员":"無異常簽到成員",
        "学员信息":"學員信息",
        "考勤状态":"考勤狀態",
        "可疑代签情况":"可疑代簽情況",
        "同账号多设备登录":"同賬號多設備登錄",
        "没有发现代签的学生":"沒有發現代簽的學生耶！",
        "暂无学生GPS签到记录":"暫無學生GPS簽到記錄",
        "签到正常":"簽到正常",
        "放弃":"放棄",
        "结束":"結束",
        "结束并完成此次考勤":"結束並完成此次考勤？",
        "考勤结束后老师可手动修改未签到学生考勤状态":"考勤結束後，老師可手動修改未簽到學生考勤狀態。",
        "放弃此次考勤":"放棄此次考勤？",
        "放弃此次考勤后此次考勤数据将清零":"放棄此次考勤後，此次考勤數據將清零。",
        "学生通过以下数字完成签到":"學生通過以下數字完成簽到",
        "更换一个":"更換壹個",
        "学生通过微信扫一扫该二维码完成签到":"學生通過微信掃壹掃該二維碼完成簽到",
        "签到时间":"簽到時間",
        "签到人":"簽到人",
        "请选择考勤方式":"請選擇考勤方式",
    },
    status: {
        '全部': '全部',
        '旷课': '曠課',
        '出勤': '出勤',
        '缺勤': '缺勤',
        '迟到': '遲到',
        '请假': '請假',
        '早退': '早退',
        '事假': '事假',
        '病假': '病假',
        '公假': '公假',
        '待签到':'待簽到',
    },
    checkInCheckOut:{
        '签入迟到':'簽入遲到',
        '签入考勤':'簽入考勤',
        '签出考勤':'簽出考勤',
        '签到':'簽到',
        "考勤时长":"考勤時長",
        "考勤结果":"考勤結果",
        "小时":"小時",
        "分钟":"分鐘",
        "分钟后考勤自动结束":"分鐘後考勤自動結束",
        "下次考勤时间":"下次考勤時間",
        "到时自动通知考勤":"到時自動通知考勤",
        "请设置":"請設置",
        "开始考勤":"開始考勤",
        "请输入持续考勤时间":"請輸入持續考勤時間",
        "请选择下次考勤时间":"請選擇下次考勤時間",
    },
    checkInCodeResult:{
        '签到失败':'簽到失敗',
        '此签到二维码已过期失效':'此簽到二維碼已過期失效，請重新掃最新',
        '签到二维码签到':'簽到二維碼簽到',
        '重新扫码':'重新掃碼',
        '该考勤不是二维码考勤':'該考勤不是二維碼考勤，無法進行掃碼簽到',
        '返回考勤列表':'返回考勤列表',
        '本次考勤已结束':'本次考勤已結束，無法完成簽到',
        '老师已停止加课':'老師已停止加課，您無法加入課程進行簽到',
        '具体情况请咨询任课老师':'具體情況請咨詢任課老師',
        '无效签到':'無效簽到',
        '您是课程老师':'您是課程老師，不需要進行該課程考勤',
        '您是该课程老师助教':'您是該課程老師/助教，不需要進行該課程考勤',
        '本课程人数已达到设定的课程人数上限':'本課程人數已達到設定的課程人數上限，您',
        '无法加入课程进行签到':'無法加入課程進行簽到，具體情況請咨詢任課老師',
        '返回课程列表':'返回課程列表',
        '恭喜您签到成功':'恭喜您簽到成功',
        '您可在考勤列表页查看考勤结果':'您可在考勤列表頁查看考勤結果',
        '同时您已成功加入课程':'同時您已成功加入課程',
        '重复签到':'重復簽到',
        '您已参与过本次扫码签到':'您已參與過本次掃碼簽到，簽到結果將以',
        '首次签到时间为准':'首次簽到時間為準，您可在考勤列表查看',
        '本次考勤已被删除':'本次考勤已被刪除',
        '未知原因':'未知原因，請重新簽到',
        '访问不合法':'訪問不合法',
        '请您用微信扫一扫老师的大屏幕的二维码':'請您用微信掃壹掃老師的大屏幕的二維碼,即可完成簽到',
        '知道啦':'知道啦',
        '签到结果':"簽到結果",
        '仅已认证身份并在选课名单中的成员才能参与本次考勤':'僅已認證身份並在選課名單中的成員才能參與本次考勤，請先認證身份並與老師核實本賬號是否在選課名單中',
        '请输入数字':'請輸入數字，手動完成簽到',
        '数字由老师处获取':'數字由老師處獲取',
        '点击签到':'點擊簽到',
        '定位准确':'定位準確',
        '定位错误':'定位錯誤',
        '重新定位':'重新定位',
        "正在定位中":"正在定位中。。。",
        "定位失败没有权限获取到地理位置请先开启GPS并且授权软件使用!这样可以提高定位的准确度":"定位失敗，沒有權限獲取到地理位置，請先開啟GPS，並且授權軟件使用!這樣可以提高定位的準確度",
        "通过微信获取地理位置信息成功":"通過微信獲取地理位置信息成功...",
        "GPS位置信息获取失败您是否还要继续签到如果您继续签到的话老师那边将会显示异常签到":"GPS位置信息獲取失敗，您是否還要繼續簽到？如果您繼續簽到的話，老師那邊將會顯示異常簽到！",
        "需要重新定位如果位置持续不准确可能您未打开GPS和授权允许":"需要重新定位？如果位置持續不準確，可能您未打開GPS和授權允許",
        "正在重新定位中":"正在重新定位中...",
        "通过微信成功获取GPS地理位置信息":"通過微信，成功獲取GPS地理位置信息",
        "通过微信地理位置坐标转换完毕":"通過微信,地理位置坐標轉換完畢",

    },
    "考勤持续时间":"考勤持續時間",
}